import { render } from "./propertyList.vue?vue&type=template&id=6cf56fc0&scoped=true"
import script from "./propertyList.vue?vue&type=script&lang=js"
export * from "./propertyList.vue?vue&type=script&lang=js"

import "./propertyList.vue?vue&type=style&index=0&id=6cf56fc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf56fc0"]])

export default __exports__